export const environment = {
  production: true,
  buildNo:202610272359,
  version: '2.0.1',
  baseUrl: 'https://ws.dory365.spientsyserv.com',
  assetsUrl: 'https://ws.dory365.spientsyserv.com/resources',
  assetsPosAdsPath: '/ads/pos',
  userId: 'epsv2',
  password: 'epsProdPass123#@!',
  appKey: "3b83c3b6b69ae6907b892320bc3d8087"
};
/**
 * passkey 3b83c3b6b69ae6907b892320bc3d8087
 */
